import { createInstance, OptimizelyProvider, setLogLevel } from '@optimizely/react-sdk';
import type { FC, ReactNode } from 'react';
import { OPTIMIZELY_CLIENT_SDK_KEY, OPTIMIZELY_LOG_LEVEL } from 'config/env';
import getOptimizelyUserId from './utils/getOptimizelyUserId';
import getOptimizelyUserGroup from './utils/getOptimizelyUserGroup';

interface Props {
  children: ReactNode;
}

const optimizely = createInstance({
  sdkKey: OPTIMIZELY_CLIENT_SDK_KEY,
  eventBatchSize: 10,
  eventFlushInterval: 1000,
});

setLogLevel(OPTIMIZELY_LOG_LEVEL);

const FeatureFlagsProvider: FC<Props> = ({ children }) => {
  const id = getOptimizelyUserId();
  const userGroup = getOptimizelyUserGroup();
  const user = {
    id,
    attributes: {
      user_group: userGroup,
    },
  };

  return (
    <OptimizelyProvider optimizely={optimizely} user={user}>
      {children}
    </OptimizelyProvider>
  );
};

export default FeatureFlagsProvider;
